// Wave AW.3-React (2026-05-16) — 가입 신청 후 검토 대기 화면.
// Wave UX-2.1 Item 1 sweep (2026-05-23) — 4 locale i18n 마이그레이션.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoFull } from '../Logo';
import { useT } from '../../i18n/I18nProvider';

function AuctionBuyerPending() {
  var navigate = useNavigate();
  var t = useT();
  return (
    <div className="buyer-root" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(180deg,#f8fafc 0%,#eff6ff 100%)',
      padding: 20,
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: -200, right: -200, width: 600, height: 600, background: '#dbeafe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4 }} />
      <div style={{ position: 'absolute', bottom: -200, left: -200, width: 500, height: 500, background: '#e0f2fe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4 }} />

      <div style={{ width: '100%', maxWidth: 480, position: 'relative', zIndex: 10 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <LogoFull iconSize={36} fontSize={24} />
        </div>

        <div style={{ backgroundColor: 'white', borderRadius: 20, padding: '48px 36px', boxShadow: '0 4px 40px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', textAlign: 'center' }}>
          <div style={{ width: 72, height: 72, margin: '0 auto 24px', borderRadius: '50%', background: 'linear-gradient(135deg, #fef3c7, #fde68a)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>
            ⏳
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginBottom: 12 }}>{t('pendingTitle')}</h2>
          <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 8 }}>
            {t('pendingBody1')}
          </p>
          <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 28 }}>
            {t('pendingBody2')}
          </p>

          <div style={{ background: '#f8fafc', borderRadius: 12, padding: 16, marginBottom: 24, textAlign: 'left' }}>
            <p style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginBottom: 8 }}>{t('pendingStepsTitle')}</p>
            <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#475569', lineHeight: 1.8 }}>
              <li>{t('pendingStep1')}</li>
              <li>{t('pendingStep2')}</li>
              <li>{t('pendingStep3')}</li>
            </ul>
          </div>

          <button type="button" onClick={function(){navigate('/buyer/login')}}
            style={{
              width: '100%', height: 44,
              background: 'white',
              color: '#1B3A5C', border: '1.5px solid #cbd5e1', borderRadius: 12,
              fontSize: 14, fontWeight: 700, cursor: 'pointer',            }}>
            {t('pendingBackToLogin')}
          </button>
        </div>

        <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 12, marginTop: 24 }}>
          {t('pendingContact')}
        </p>
      </div>
    </div>
  );
}

export default AuctionBuyerPending;
